module.exports = __webpack_public_path__ + "assets/ubike1.jpg?cf0324b0739468e43cf3427970fe67d4";